/* globals Store */

import api from '@/utils/api/tap-api'
import { TrainerProfile, Certification, Education, Work, Skill, Kyc, TrainerPackage, Client, ClientDto } from '@/models'
import {
  sendSuccessNotice,
  sendErrorNotice,
  closeNotice
} from '@/utils/store-util.js'
import utilities from '@/utils/utilities'
const state = {
  profile: new TrainerProfile(),
  certificationList: [],
  certification: new Certification(),
  educationList: [],
  education: new Education(),
  workExperienceList: [],
  work: new Work(),
  kycList: [],
  kyc: new Kyc(),
  skillList: [],
  skill: new Skill(),
  trainerPackageList: [],
  trainerPackage: new TrainerPackage(),
  clientList: [],
  client: new ClientDto('', [new Client()]),
  loading: false
}

const getters = {
}

const actions = {
  logout ({ commit }) {
    commit('setProfile', null)
    commit('setCertification', null)
    commit('setCertificationList', [])
    commit('setEducationList', [])
    commit('setEducation', null)
    commit('setWorkExperienceList', [])
    commit('setWorkExperience', null)
    commit('setKycList', [])
    commit('setKyc', null)
    commit('setSkillList', [])
    commit('setSkill', null)
    commit('setTrainerPackageList', [])
    commit('setTrainerPackage', null)
    commit('setClientList', [])
    commit('setClient', null)
    commit('setLoading', false)
  },
  downloadDocument ({ commit }, url) {
    commit('setLoading', true)
    api.downloadData('user/downloadFromS3?url=' + url)
    .then(res => {
      const urlDownload = window.URL.createObjectURL(new Blob([res.data]))
      const link = document.createElement('a')
      link.href = urlDownload
      let fileName = url.substring(83)
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
    })
    .catch(err => {
      console.log('error ocuured in download')
      console.log(err)
      sendErrorNotice(commit, 'Resume download Failed! Please try again later.')
      closeNotice(commit, 20000)
    })
    .finally(() => {
      commit('setLoading', false)
    })
  },
  uploadDocument ({ commit }, {data, type, cb}) {
    if (data === null) {
      sendErrorNotice(null, 'No file selected to save')
      closeNotice(commit, 20000)
    } else {
      commit('setLoading', true)
      let formData = new FormData()
      formData.append('file', data)
      api.uploadData('user/uploadToS3/cv', formData)
      .then(res => {
        if (res.data.status === 'SUCCESS') {
          if (type === 'resume') {
            let profile = { ...Store.state.profile.profile }
            profile.resumePrivateUrl = res.data.data[0]
            Store.dispatch('profile/saveProfile', {profile, cb})
          } else if (type === 'courseoutline') {
            let trainerPackage = { ...Store.state.profile.trainerPackage }
            trainerPackage.outlineDocument = res.data.data[0]
            commit('setTrainerPackage', trainerPackage)
          }
          cb()
        } else {
          Store.dispatch('project/dealUnsuccessResponse', res.data)
        }
        commit('setLoading', false)
      })
      .catch(err => {
        console.log(err)
        sendErrorNotice(commit, 'Profile Pic Upload Failed! Please try again later.')
        closeNotice(commit, 20000)
        commit('setLoading', false)
      })
    }
  },
  getEducationList ({ commit }) {
    api.getData('user/education')
    .then(res => {
      if (res.data.status === 'SUCCESS') {
        commit('setEducationList', res.data.data)
      }
    })
  },
  deleteEducation ({commit}, {id, cb}) {
    commit('setLoading', true)
    api.deleteData('user/education/' + id)
    .then(res => {
      if (res.data.status === 'SUCCESS') {
        commit('deleteEducation', id)
        commit('setEducation', null)
        if (Store.state.profile.educationList.length === 0) {
          Store.dispatch('user/updateCompletion')
        }
        sendSuccessNotice(commit, 'Education Information has been deleted.')
        closeNotice(commit, 1500)
        cb()
      } else {
        Store.dispatch('project/dealUnsuccessResponse', res.data)
      }
      commit('setLoading', false)
    })
    .catch(err => {
      console.log(err)
      sendErrorNotice(commit, 'Operation failed! Please try again later. ')
      closeNotice(commit, 20000)
      commit('setLoading', false)
    })
  },
  saveEducation ({ commit }, {education, cb}) {
    if (education.id === null) {
      // create case
      commit('setLoading', true)
      api.postData('user/education', education)
      .then(res => {
        if (res.data.status === 'SUCCESS') {
          if (res.data.data.length === 1) {
            Store.dispatch('user/updateCompletion')
          }
          commit('setEducationList', res.data.data)
          commit('setEducation', null)
          sendSuccessNotice(commit, 'Education Information has been added.')
          closeNotice(commit, 1500)
          cb()
        } else {
          Store.dispatch('project/dealUnsuccessResponse', res.data)
        }
        commit('setLoading', false)
      })
      .catch(err => {
        console.log(err)
        sendErrorNotice(commit, 'Operation failed! Please try again later. ')
        closeNotice(commit, 20000)
        commit('setLoading', false)
      })
    } else {
      // edit case
      commit('setLoading', true)
      api.putData('user/education', education)
      .then(res => {
        if (res.data.status === 'SUCCESS') {
          commit('setEducationList', res.data.data)
          commit('setEducation', null)
          sendSuccessNotice(commit, 'Education Information has been updated.')
          closeNotice(commit, 1500)
          cb()
        } else {
          Store.dispatch('project/dealUnsuccessResponse', res.data)
        }
        commit('setLoading', false)
      })
      .catch(err => {
        console.log(err)
        sendErrorNotice(commit, 'Operation failed! Please try again later. ')
        closeNotice(commit, 20000)
        commit('setLoading', false)
      })
    }
  },
  updateEducationForm ({ commit }, education) {
    commit('setEducation', education)
  },
  getWorkExperienceList ({ commit }) {
    api.getData('user/work')
    .then(res => {
      if (res.data.status === 'SUCCESS') {
        commit('setWorkExperienceList', res.data.data)
      }
    })
  },
  deleteWorkExperience ({commit}, {id, cb}) {
    commit('setLoading', true)
    api.deleteData('user/work/' + id)
    .then(res => {
      if (res.data.status === 'SUCCESS') {
        commit('deleteWorkExperience', id)
        if (Store.state.profile.workExperienceList.length === 0) {
          Store.dispatch('user/updateCompletion')
        }
        sendSuccessNotice(commit, 'Work Information has been deleted.')
        closeNotice(commit, 1500)
        cb()
      } else {
        Store.dispatch('project/dealUnsuccessResponse', res.data)
      }
      commit('setLoading', false)
    })
    .catch(err => {
      console.log(err)
      sendErrorNotice(commit, 'Operation failed! Please try again later. ')
      closeNotice(commit, 20000)
      commit('setLoading', false)
    })
  },
  saveWorkExprience ({commit}, {work, cb}) {
    if (work.id === null) {
      // create case
      commit('setLoading', true)
      api.postData('user/work', work)
      .then(res => {
        if (res.data.status === 'SUCCESS') {
          if (res.data.data.length === 1) {
            Store.dispatch('user/updateCompletion')
          }
          commit('setWorkExperienceList', res.data.data)
          commit('setWorkExperience', null)
          sendSuccessNotice(commit, 'Work Information has been added.')
          closeNotice(commit, 1500)
          cb()
        } else {
          Store.dispatch('project/dealUnsuccessResponse', res.data)
        }
        commit('setLoading', false)
      })
      .catch(err => {
        console.log(err)
        sendErrorNotice(commit, 'Operation failed! Please try again later. ')
        closeNotice(commit, 20000)
        commit('setLoading', false)
      })
    } else {
      // edit case
      api.putData('user/work', work)
      .then(res => {
        if (res.data.status === 'SUCCESS') {
          commit('setWorkExperienceList', res.data.data)
          commit('setWorkExperience', null)
          sendSuccessNotice(commit, 'Work Information has been updated.')
          closeNotice(commit, 1500)
          cb()
        } else {
          Store.dispatch('project/dealUnsuccessResponse', res.data)
        }
      })
      .catch(err => {
        console.log(err)
        sendErrorNotice(commit, 'Operation failed! Please try again later. ')
        closeNotice(commit, 20000)
      })
    }
  },
  updateWorkExperienceForm ({ commit }, work) {
    commit('setWorkExperience', work)
  },
  getProfile ({ commit }) {
    api.getData('user/profile')
    .then(res => {
      if (res.data.status === 'SUCCESS') {
        commit('setProfile', res.data.data[0])
      } else {
        Store.dispatch('project/dealUnsuccessResponse', res.data)
      }
    })
  },
  saveProfile ({ commit }, {profile, cb}) {
    if (profile.id === null) {
      // create case
      api.postData('user/profile', profile)
      .then(res => {
        if (res.data.status === 'SUCCESS') {
          Store.dispatch('user/updateCompletion')
          commit('setProfile', res.data.data[0])
          sendSuccessNotice(commit, 'Profile Information has been updated.')
          closeNotice(commit, 1500)
          if (cb) cb()
        } else {
          Store.dispatch('project/dealUnsuccessResponse', res.data)
        }
        commit('setLoading', false)
      })
      .catch(err => {
        console.log(err)
        sendErrorNotice(commit, 'Operation failed! Please try again later. ')
        closeNotice(commit, 20000)
        commit('setLoading', false)
      })
    } else {
      // edit case
      api.putData('user/profile', profile)
      .then(res => {
        if (res.data.status === 'SUCCESS') {
          commit('setProfile', res.data.data[0])
          sendSuccessNotice(commit, 'Profile Information has been updated.')
          closeNotice(commit, 1500)
        } else {
          Store.dispatch('project/dealUnsuccessResponse', res.data)
        }
      })
      .catch(err => {
        console.log(err)
        sendErrorNotice(commit, 'Operation failed! Please try again later. ')
        closeNotice(commit, 20000)
      })
    }
  },
  getCertificationList ({ commit }) {
    api.getData('user/certification')
    .then(res => {
      if (res.data.status === 'SUCCESS') {
        commit('setCertificationList', res.data.data)
      }
    })
  },
  saveCertification ({ commit }, {certification, cb}) {
    if (certification.id === null) {
      // create case
      commit('setLoading', true)
      api.postData('user/certification', certification)
      .then(res => {
        if (res.data.status === 'SUCCESS') {
          if (res.data.data.length === 1) {
            Store.dispatch('user/updateCompletion')
          }
          commit('setCertificationList', res.data.data)
          commit('setCertification', null)
          sendSuccessNotice(commit, 'Certification Information has been added.')
          closeNotice(commit, 1500)
          cb()
        } else {
          Store.dispatch('project/dealUnsuccessResponse', res.data)
        }
        commit('setLoading', false)
      })
      .catch(err => {
        console.log(err)
        sendErrorNotice(commit, 'Operation failed! Please try again later. ')
        closeNotice(commit, 20000)
        commit('setLoading', false)
      })
    } else {
      // edit case
      api.putData('user/certification', certification)
      .then(res => {
        if (res.data.status === 'SUCCESS') {
          commit('setCertificationList', res.data.data)
          commit('setCertification', null)
          sendSuccessNotice(commit, 'Certification Information has been updated.')
          closeNotice(commit, 1500)
          cb()
        } else {
          Store.dispatch('project/dealUnsuccessResponse', res.data)
        }
      })
      .catch(err => {
        console.log(err)
        sendErrorNotice(commit, 'Operation failed! Please try again later.')
        closeNotice(commit, 20000)
      })
    }
  },

  getTrainerPackageList ({ commit }) {
    api.getData('user/package')
    .then(res => {
      if (res.data.status === 'SUCCESS') {
        commit('setTrainerPackageList', res.data.data)
      }
    })
  },
  saveTrainerPackage ({ commit }, {formData, cb}) {
    commit('setLoading', true)
    api.uploadData('user/package', formData)
    .then(res => {
      if (res.data.status === 'SUCCESS') {
        console.log('saveSuccess')
        if (res.data.data.length === 1) {
          Store.dispatch('user/updateCompletion')
        }
        commit('setTrainerPackageList', res.data.data)
        commit('setTrainerPackage', null)
        if (formData.get('id') === null) {
          sendSuccessNotice(commit, 'Package has been added.')
        } else {
          sendSuccessNotice(commit, 'Package has been updated.')
        }
        closeNotice(commit, 1500)
        cb()
      } else {
        Store.dispatch('project/dealUnsuccessResponse', res.data)
      }
      commit('setLoading', false)
    })
    .catch(err => {
      console.log(err)
      sendErrorNotice(commit, 'Operation failed! Please try again later.')
      closeNotice(commit, 20000)
      commit('setLoading', false)
    })
  },

  getClientList ({ commit }) {
    api.getData('user/client')
    .then(res => {
      if (res.data.status === 'SUCCESS') {
        let clientNameObjectArray = utilities.getClientNameObjectArray(res.data.data)
        commit('setClientList', clientNameObjectArray)
      } else {
        Store.dispatch('project/dealUnsuccessResponse', res.data)
      }
    })
    .catch(err => {
      console.log(err)
      sendErrorNotice(commit, 'Operation failed! Please try again later.')
      closeNotice(commit, 20000)
    })
  },
  addClient ({ commit }, {clientDto, cb}) {
    let clientList = utilities.getClientList(clientDto)
    commit('setLoading', true)
    api.postData('user/client', clientList)
    .then(res => {
      if (res.data.status === 'SUCCESS') {
        if (res.data.data.length === 1) {
          Store.dispatch('user/updateCompletion')
        }
        let clientNameObjectArray = utilities.getClientNameObjectArray(res.data.data)
        commit('setClientList', clientNameObjectArray)
        commit('setClient', null)
        sendSuccessNotice(commit, 'Client Information has been added.')
        closeNotice(commit, 1500)
        cb()
      } else {
        Store.dispatch('project/dealUnsuccessResponse', res.data)
      }
      commit('setLoading', false)
    })
    .catch(err => {
      console.log(err)
      sendErrorNotice(commit, 'Operation failed! Please try again later. ')
      closeNotice(commit, 20000)
      commit('setLoading', false)
    })
  },
  editClient ({ commit }, {clientDto, cb}) {
    console.log('catch me')
    commit('setLoading', true)
    let clientList = utilities.getClientList(clientDto)
    api.putData('user/client', clientList)
    .then(res => {
      if (res.data.status === 'SUCCESS') {
        let clientNameObjectArray = utilities.getClientNameObjectArray(res.data.data)
        commit('setClientList', clientNameObjectArray)
        commit('setClient', null)
        sendSuccessNotice(commit, 'Client Information has been updated.')
        closeNotice(commit, 1500)
        cb()
      } else {
        Store.dispatch('project/dealUnsuccessResponse', res.data)
      }
      commit('setLoading', false)
    })
    .catch(err => {
      console.log(err)
      sendErrorNotice(commit, 'Operation failed! Please try again later.')
      closeNotice(commit, 20000)
      commit('setLoading', false)
    })
  },
  saveKyc ({ commit }, {kyc, cb}) {
    if (kyc.id === null) {
      // create case
      api.postData('user/kyc', kyc)
      .then(res => {
        if (res.data.status === 'SUCCESS') {
          if (res.data.data.length === 1) {
            Store.dispatch('user/updateCompletion')
          }
          commit('setKycList', res.data.data)
          commit('setKyc', null)
          sendSuccessNotice(commit, 'Kyc Information has been added.')
          closeNotice(commit, 1500)
          cb()
        } else {
          Store.dispatch('project/dealUnsuccessResponse', res.data)
        }
      })
      .catch(err => {
        console.log(err)
        sendErrorNotice(commit, 'Operation failed! Please try again later. ')
        closeNotice(commit, 20000)
      })
    } else {
      // edit case
      api.putData('user/kyc', kyc)
      .then(res => {
        if (res.data.status === 'SUCCESS') {
          commit('setKycList', res.data.data)
          commit('setKyc', null)
          sendSuccessNotice(commit, 'Kyc Information has been updated.')
          closeNotice(commit, 1500)
          cb()
        } else {
          Store.dispatch('project/dealUnsuccessResponse', res.data)
        }
      })
      .catch(err => {
        console.log(err)
        sendErrorNotice(commit, 'Operation failed! Please try again later.')
        closeNotice(commit, 20000)
      })
    }
  },
  deleteCertification ({commit}, {id, cb}) {
    commit('setLoading', true)
    api.deleteData('user/certification/' + id)
    .then(res => {
      if (res.data.status === 'SUCCESS') {
        commit('deleteCertification', id)
        if (Store.state.profile.certificationList.length === 0) {
          Store.dispatch('user/updateCompletion')
        }
        sendSuccessNotice(commit, 'Certification Information has been deleted.')
        closeNotice(commit, 1500)
        cb()
      } else {
        Store.dispatch('project/dealUnsuccessResponse', res.data)
      }
      commit('setLoading', false)
    })
    .catch(err => {
      console.log(err)
      sendErrorNotice(commit, 'Operation failed! Please try again later.')
      closeNotice(commit, 20000)
      commit('setLoading', false)
    })
  },
  deleteTrainerPackage ({commit}, {id, cb}) {
    commit('setLoading', true)
    api.deleteData('user/package/' + id)
    .then(res => {
      if (res.data.status === 'SUCCESS') {
        commit('deleteTrainerPackage', id)
        if (Store.state.profile.trainerPackageList.length === 0) {
          Store.dispatch('user/updateCompletion')
        }
        sendSuccessNotice(commit, 'TrainerPackage Information has been deleted.')
        closeNotice(commit, 1500)
        cb()
      } else {
        Store.dispatch('project/dealUnsuccessResponse', res.data)
      }
      commit('setLoading', false)
    })
    .catch(err => {
      console.log(err)
      sendErrorNotice(commit, 'Operation failed! Please try again later.')
      closeNotice(commit, 20000)
      commit('setLoading', false)
    })
  },
  deleteClient ({commit}, {clientName, cb}) {
    commit('setLoading', true)
    api.deleteData('user/client/' + clientName)
    .then(res => {
      if (res.data.status === 'SUCCESS') {
        commit('deleteClient', clientName)
        if (Store.state.profile.clientList.length === 0) {
          Store.dispatch('user/updateCompletion')
        }
        sendSuccessNotice(commit, 'Client Information has been deleted.')
        closeNotice(commit, 1500)
        cb()
      } else {
        Store.dispatch('project/dealUnsuccessResponse', res.data)
      }
      commit('setLoading', false)
    })
    .catch(err => {
      console.log(err)
      sendErrorNotice(commit, 'Operation failed! Please try again later.')
      closeNotice(commit, 20000)
      commit('setLoading', false)
    })
  },

  getKycList ({ commit }) {
    api.getData('user/kyc')
    .then(res => {
      if (res.data.status === 'SUCCESS') {
        commit('setKycList', res.data.data)
      }
    })
  },
  deleteKyc ({commit}, id) {
    api.deleteData('user/kyc/' + id)
    .then(res => {
      if (res.data.status === 'SUCCESS') {
        commit('deleteKyc', id)
        if (Store.state.profile.kycList.length === 0) {
          Store.dispatch('user/updateCompletion')
        }
         // commit('setCertification', null)
        sendSuccessNotice(commit, 'Kyc Information has been deleted.')
        closeNotice(commit, 1500)
      } else {
        Store.dispatch('project/dealUnsuccessResponse', res.data)
      }
    })
  },
  updateCertificationForm ({ commit }, certification) {
    commit('setCertification', certification)
  },

  updateTrainerPackageForm ({ commit }, trainerPackage) {
    commit('setTrainerPackage', trainerPackage)
  },

  updateClientForm ({ commit }, trainingList) {
    commit('setClient', trainingList)
  },

  trainingList ({ commit }, index) {
    if (index === null) {
      // add
      commit('addTraining')
    } else {
      // delete
      commit('deleteTraining', index)
    }
  },

  updateKycForm ({ commit }, kyc) {
    commit('setKyc', kyc)
  },
  getSkillList ({ commit }) {
    api.getData('user/skill')
    .then(res => {
      if (res.data.status === 'SUCCESS') {
        commit('setSkillList', res.data.data)
      }
    })
  },
  saveSkill ({ commit }, {skill, cb}) {
    if (skill.id === null) {
      // create case
      commit('setLoading', true)
      api.postData('user/skill', skill)
      .then(res => {
        if (res.data.status === 'SUCCESS') {
          if (res.data.data.length === 1) {
            Store.dispatch('user/updateCompletion')
          }
          commit('setSkillList', res.data.data)
          commit('setSkill', null)
          sendSuccessNotice(commit, 'Skill Information has been added.')
          closeNotice(commit, 1500)
          cb()
        } else {
          Store.dispatch('project/dealUnsuccessResponse', res.data)
        }
        commit('setLoading', false)
      })
      .catch(err => {
        console.log(err)
        sendErrorNotice(commit, 'Operation failed! Please try again later. ')
        closeNotice(commit, 20000)
        commit('setLoading', false)
      })
    } else {
      // edit case
      api.putData('user/skill', skill)
      .then(res => {
        if (res.data.status === 'SUCCESS') {
          commit('setSkillList', res.data.data)
          commit('setSkill', null)
          sendSuccessNotice(commit, 'Skill Information has been updated.')
          closeNotice(commit, 1500)
          cb()
        } else {
          Store.dispatch('project/dealUnsuccessResponse', res.data)
        }
      })
      .catch(err => {
        console.log(err)
        sendErrorNotice(commit, 'Operation failed! Please try again later.')
        closeNotice(commit, 20000)
      })
    }
  },
  deleteSkill ({commit}, {id, cb}) {
    commit('setLoading', true)
    api.deleteData('user/skill/' + id)
    .then(res => {
      if (res.data.status === 'SUCCESS') {
        commit('deleteSkill', id)
        if (Store.state.profile.skillList.length === 0) {
          Store.dispatch('user/updateCompletion')
        }
        sendSuccessNotice(commit, 'Skill Information has been deleted.')
        closeNotice(commit, 1500)
        cb()
      } else {
        Store.dispatch('project/dealUnsuccessResponse', res.data)
      }
      commit('setLoading', false)
    })
    .catch(err => {
      console.log(err)
      sendErrorNotice(commit, 'Operation failed! Please try again later.')
      closeNotice(commit, 20000)
      commit('setLoading', false)
    })
  },
  updateSkillForm ({ commit }, skill) {
    commit('setSkill', skill)
  }
}

const mutations = {
  setLoading (state, value) {
    state.loading = value
  },
  setEducationList (state, educationList) {
    state.educationList = educationList
  },
  setEducation (state, education) {
    if (education === null) {
      state.education = new Education()
    } else {
      state.education = education
    }
  },
  deleteEducation (state, id) {
    let educationList = state.educationList
    for (let i = 0; i < educationList.length; i++) {
      if (educationList[i].id === id) {
        state.educationList.splice(i, 1)
        break
      }
    }
  },
  setWorkExperienceList (state, workExperienceList) {
    state.workExperienceList = workExperienceList
  },
  setWorkExperience (state, work) {
    if (work === null) {
      state.work = new Work()
    } else {
      state.work = work
    }
  },
  deleteWorkExperience (state, id) {
    let workExperienceList = state.workExperienceList
    for (let i = 0; i < workExperienceList.length; i++) {
      if (workExperienceList[i].id === id) {
        state.workExperienceList.splice(i, 1)
        break
      }
    }
  },
  setProfile (state, profile) {
    if (profile === undefined || profile === null) {
      state.profile = new TrainerProfile()
    } else {
      state.profile = profile
    }
  },
  setCertificationList (state, certificationList) {
    state.certificationList = certificationList
  },
  setCertification (state, certification) {
    if (certification === null) {
      state.certification = new Certification()
    } else {
      state.certification = certification
    }
  },

  setTrainerPackageList (state, trainerPackageList) {
    state.trainerPackageList = trainerPackageList
  },
  setTrainerPackage (state, trainerPackage) {
    if (trainerPackage === null) {
      state.trainerPackage = new TrainerPackage()
    } else {
      state.trainerPackage = trainerPackage
    }
  },

  setClientList (state, clientList) {
    state.clientList = clientList
  },

  setClient (state, trainingList) {
    if (trainingList === null) {
      // add
      state.client = new ClientDto('', [new Client()])
    } else {
      // edit
      state.client = new ClientDto(trainingList[0].clientName, trainingList)
    }
  },
  deleteClient (state, clientName) {
    delete state.clientList[clientName]
  },
  // from card
  addTraining (state) {
    state.client.trainingList.push(new Client())
  },
  deleteTraining (state, index) {
    state.client.trainingList.splice(index, 1)
  },
  setSkillList (state, skillList) {
    state.skillList = skillList
  },
  setSkill (state, skill) {
    if (skill === null) {
      state.skill = new Skill()
    } else {
      state.skill = skill
    }
  },
  deleteCertification (state, id) {
    let certificationList = state.certificationList
    for (let i = 0; i < certificationList.length; i++) {
      if (certificationList[i].id === id) {
        state.certificationList.splice(i, 1)
        break
      }
    }
  },

  deleteTrainerPackage (state, id) {
    let trainerPackageList = state.trainerPackageList
    for (let i = 0; i < trainerPackageList.length; i++) {
      if (trainerPackageList[i].id === id) {
        state.trainerPackageList.splice(i, 1)
        break
      }
    }
  },

  deleteSkill (state, id) {
    let skillList = state.skillList
    for (let i = 0; i < skillList.length; i++) {
      if (skillList[i].id === id) {
        state.skillList.splice(i, 1)
        break
      }
    }
  },
  setKycList (state, kycList) {
    state.kycList = kycList
  },
  setKyc (state, kyc) {
    if (kyc === null) {
      state.kyc = new Kyc()
    } else {
      state.kyc = kyc
    }
  },
  deleteKyc (state, id) {
    let kycList = state.kycList
    for (let i = 0; i < kycList.length; i++) {
      if (kycList[i].id === id) {
        state.kycList.splice(i, 1)
        break
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/profile.js